import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
const Home = lazy(() => import('./pages/Home').then(m => ({
  default: m.Home
})));
const Services = lazy(() => import('./pages/Services').then(m => ({
  default: m.Services
})));
const Shop = lazy(() => import('./pages/Shop').then(m => ({
  default: m.Shop
})));
const Courses = lazy(() => import('./pages/Courses').then(m => ({
  default: m.Courses
})));
const About = lazy(() => import('./pages/About').then(m => ({
  default: m.About
})));
const Events = lazy(() => import('./pages/Events').then(m => ({
  default: m.Events
})));
const Community = lazy(() => import('./pages/Community').then(m => ({
  default: m.Community
})));
const Contact = lazy(() => import('./pages/Contact').then(m => ({
  default: m.Contact
})));
function PageLoader() {
  return <div className="min-h-[70vh] flex items-center justify-center bg-warmwhite" data-id="element-0" data-mp="3ikqyfyb7r257">
      <div className="flex flex-col items-center gap-4" data-id="element-1" data-mp="3mlaxj7fckftz">
        <div className="w-10 h-10 border-4 border-plum/15 border-t-fuchsia rounded-full animate-spin" data-id="element-2" data-mp="3mjq3rk0ux0x6" />
        <p className="text-charcoal/50 text-sm tracking-wide" data-id="element-3" data-mp="3recf5n6xuth9">Loading…</p>
      </div>
    </div>;
}
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return null;
}
export function App() {
  return <Router data-id="element-4" data-mp="33oi2p6qj76xj">
      <ScrollToTop data-id="element-5" data-mp="38lrrqla0dgku" />
      <div className="flex flex-col min-h-screen w-full bg-warmwhite overflow-x-hidden" data-id="element-6" data-mp="38li9jjv7gdpp">
        <Navbar data-id="element-7" data-mp="3dle1gkqmoeow" />
        <div className="flex-1 animate-page-in" data-id="element-8" data-mp="3dlw727z6k59h">
          <Suspense fallback={<PageLoader data-id="element-10" data-mp="nvsvh92bsvy2" />} data-id="element-9" data-mp="3dii3wxiozs0z">
            <Routes data-id="element-11" data-mp="nuhg0bzipzr4">
              <Route path="/" element={<Home data-id="element-13" data-mp="nxn902b9pls4" />} data-id="element-12" data-mp="nv0ypuwzss67" />
              <Route path="/services" element={<Services data-id="element-15" data-mp="stkjhrzunxwz" />} data-id="element-14" data-mp="sudmqizlo5ad" />
              <Route path="/shop" element={<Shop data-id="element-17" data-mp="36hzxgtw5a5z" />} data-id="element-16" data-mp="ssstcwp0use3" />
              <Route path="/courses" element={<Courses data-id="element-19" data-mp="34x29ica5b3w" />} data-id="element-18" data-mp="35oxgs1yt6tn" />
              <Route path="/events" element={<Events data-id="element-21" data-mp="3udazkg91d18e" />} data-id="element-20" data-mp="38b6kw4i7udz" />
              <Route path="/community" element={<Community data-id="element-23" data-mp="3uf5ijp0qyj9u" />} data-id="element-22" data-mp="3ubztg9s4bhe4" />
              <Route path="/about" element={<About data-id="element-25" data-mp="d3cvbquvaug1" />} data-id="element-24" data-mp="d57h17dyqql6" />
              <Route path="/contact" element={<Contact data-id="element-27" data-mp="85uivqhn5x3a" />} data-id="element-26" data-mp="d2l9h7r2ob2y" />
              <Route path="*" element={<Home data-id="element-29" data-mp="864d5q9pyqes" />} data-id="element-28" data-mp="86mev2f5hwu3" />
            </Routes>
          </Suspense>
        </div>
        <Footer data-id="element-30" data-mp="3gmft1am0ew7z" />
      </div>
    </Router>;
}